import notificationSoundMp3 from 'shared/ui/sound/notification.mp3'

let isAudioInitialized = false

const audio = new Audio(notificationSoundMp3)
audio.volume = 0
audio.muted = true

export const initSound = () => {
  if (isAudioInitialized) return
  console.log('audio initialized')

  audio
    .play()
    .then(() => {
      isAudioInitialized = true
    })
    .catch((error) => console.error('Sound init error:', error))
}

export const playAudio = () => {
  try {
    audio.volume = 0.5
    audio.muted = false
    audio.play().catch(console.error)
  } catch (e) {
    console.error('Sound error:', e)
  }
}
